import { Button, Image, message, Spin } from "antd";
import React, { Component } from "react";
import { connect } from "react-redux";
import share from "../../assets/share.svg";
import {
  addProductToCart,
  removeProductToCart,
} from "../../redux/cart/cart.action";
import "./ProductCard.scss";
import {
  PlusCircleOutlined,
  MinusCircleOutlined,
  DeleteFilled,
  LoadingOutlined,
  HeartTwoTone,
  HeartFilled
} from "@ant-design/icons";
import {
  addProductUserCart,
  favProductUserCart,
  removeProductUserCart,
  updateProductUserCart,
} from "../../network/product.network";
import { fallbackImg } from "../../constants/constants";
import localization from '../../Localization/Localization.json'
import { Link, withRouter } from "react-router-dom";
class ProductCard extends Component {
  state = {
    isCardAdded: false,
    card_amount: null,
    btnLoading: false,
    updateLoading: false,
    card: null,
  };

  componentDidMount() {
    const { card } = this.props;
    // console.log(card );
    const quantityIdxActive =
      card?.inCart && card?.quantities.indexOf(card?.inCart?.quantity);
    this.setState(
      {
        card,
        card_amount: {
          quantities: card.quantities,
          inCart: card.inCart,
          quantitiesIndex: quantityIdxActive || 0,
        },
      },
      () => { 
        setTimeout(() => {
          // console.log('checkProductIncart');
          // console.log(this.props.card); 
          this.checkProductIncart();  
        }, 400) 
        
      }
    );
  }

  checkProductIncart = () => { 
    const { card } = this.state;
    if (card.inCart) {
      this.setState({ isCardAdded: true });
      const isProductExistInStorage = this.props.cartItems.some(
        (product) => product.id === card.id
      );
      if (!isProductExistInStorage) {
        console.log('!isProductExistInStorage') 
        console.log(card); 
        this.props.dispatch(addProductToCart({ ...card }));
      }
    } else {
      const isProductExistInStorage = this.props.cartItems.some(
        (product) => product.id === card.id
      );
      isProductExistInStorage && this.setState({ isCardAdded: true });
    }
  };

  handelAddProductToCart = (product) => {
    const { card_amount, card } = this.state;
    // if(!this.props.currentUser){

    // }
    this.setState({ btnLoading: true });
    let body = new FormData();
    body.append("productId", product.id);
    body.append("quantity", product.quantities[0]);
    body.append("offerId", this.props.offerID ? this.props.offerID : ""); 
    addProductUserCart(
      body,
      (res) => {
        if (res.data.code === 200) {
          message.success(res.data.message);
          let newCard = { ...card };
          newCard.inCart = {
            itemId: res.data.data.item.id,
            quantity: res.data.data.item.quantity,
          };
          console.log(newCard);
          this.setState({
            isCardAdded: true,
            btnLoading: false,
            card: newCard,
          });
          this.props.dispatch(
            addProductToCart({
              ...product,
              inCart: {
                itemId: res.data.data.item.id,
                quantity: res.data.data.item.quantity,
              },
              product_cart_count: card_amount?.quantitiesIndex,
            })
          );
        }else{
          this.setState({ btnLoading: false });
        }
      },
      (error) => {
        this.setState({ btnLoading: false });
        console.log(error);
      }
    );
  };

  handelUpdateProduct = (controlType) => {
    const { card_amount, card } = this.state;
    this.setState({ updateLoading: true });
    let body = new FormData();
    body.append("itemId", card?.inCart?.itemId);
    body.append(
      "quantity",
      card?.quantities[
        controlType === "inc"
          ? card_amount?.quantitiesIndex + 1
          : card_amount?.quantitiesIndex - 1
      ]
    );
    updateProductUserCart(
      body,
      (res) => {
        this.setState({ updateLoading: false });
        if (res.data.code === 200) {
          message.success(localization.productupdatedsuccessfully[this.props.currentLang]);
          controlType === "inc"
            ? this.setState({
                card_amount: {
                  ...card_amount,
                  quantitiesIndex: +card_amount.quantitiesIndex + 1,
                },
              })
            : this.setState({
                card_amount: {
                  ...card_amount,
                  quantitiesIndex: +card_amount.quantitiesIndex - 1,
                },
              });
        }
      },
      (error) => {
        this.setState({ updateLoading: false });
        console.log(error);
      }
    );
  };

  handelDltProduct = () => {
    const { card } = this.state;
    console.log(card);
    this.setState({ updateLoading: true });
    let body = new FormData();
    body.append("itemId", card?.inCart?.itemId);
    removeProductUserCart(
      body,
      (res) => {
        this.setState({ updateLoading: false });
        if (res.data.code === 200) {
          this.setState({ isCardAdded: false });
          message.success(res.data.message);
          if(this.props.showCartCard){
            this.props.removeItemFromList(card.id); 
          }
          this.props.dispatch(removeProductToCart(card.id));
        }
      },
      (error) => {
        this.setState({ updateLoading: false });
        console.log(error);
      }
    );
  };

  handelFavProduct = () => {
    const { card } = this.state;
    console.log(card);
    this.setState({ updateLoading: true });
    let body = new FormData();
    body.append("product", +card?.id); 
    favProductUserCart(
      body,
      (res) => {
        this.setState({ updateLoading: false });
        if (res.data.code === 200) {
          message.success(res.data.message);
          if(this.props.showFavCard){ 
            this.props.removeItemFromfav(card.id);  
          }
          this.setState({card : {...card, isFavorite : res.data.item}}) 
        }
      },
      (error) => {
        this.setState({ updateLoading: false });
        console.log(error);
      }
    );
  };

  render() {
    const { discount, showCartCard, currentLang, showFavCard } = this.props;
    const { isCardAdded, card_amount, btnLoading, card, updateLoading } =
      this.state;
    return (
      <>
        {showCartCard ? (
          <div className="cart-product-card"> 
            <div className="product-img" onClick={() => this.props.history.push(`/product/${card?.id}/${card?.name}`)}>
              {/* <Link>  */}
              <Image
                src={card?.image_link || card?.image || fallbackImg}
                fallback={fallbackImg}
                preview={false}
                />
                {/* </Link> */}
            </div>
            <div className="cart-product--content">
            <div className="product-info">
              <h6 className="product-name">{card?.productName || card?.name}</h6> 
              <div className="price-holder">
              <p className="price-after ddd">
                {card?.discount_price ? card?.price : card?.price} <span>{localization.AED[currentLang]}</span>
              </p>
              {/* {card?.discount_price && (
                <p className="price-before">{card?.price} {localization.AED[currentLang]}</p>
              )} */}
            </div>
            </div>

            <div className="product-control-holder">
              {showFavCard ? 
            <div className="card-control">
            {isCardAdded ? (
                <Spin
                  indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />}
                  spinning={updateLoading}
                >
                  <div className="card-count-holder">
                    <Button
                      onClick={() => this.handelUpdateProduct("dec")}
                      disabled={card_amount?.quantitiesIndex === 0}
                    >
                      <MinusCircleOutlined />
                    </Button>
                    <p className="product-count">
                      {isCardAdded
                        ? card_amount?.quantities[card_amount?.quantitiesIndex]
                        : null}
                    </p>
                    <Button
                      onClick={() => this.handelUpdateProduct("inc")}
                      disabled={
                        card_amount?.quantitiesIndex ===
                        card?.quantities?.length - 1
                      }
                    >
                      <PlusCircleOutlined />
                    </Button>
                    
                  </div>
                </Spin>) : 
                (
                  <Button
                    loading={btnLoading}
                    type="primary"
                    size="large"
                    block
                    ghost
                    style={{width : 155}}
                    onClick={() => this.handelAddProductToCart(card)}
                  >
                    {localization.Addtocart[currentLang]} 
                  </Button>
                )
                }
            </div> :  
            <Spin
            indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />}
            spinning={updateLoading}
          >
            <div className="card-count-holder">
              <Button 
                onClick={() => this.handelUpdateProduct("dec")}
                disabled={card_amount?.quantitiesIndex === 0}
              >
                <MinusCircleOutlined />
              </Button>
              <p className="product-count">
                {isCardAdded
                  ? card_amount?.quantities[card_amount?.quantitiesIndex]
                  : null}
              </p>
              <Button
                onClick={() => this.handelUpdateProduct("inc")}
                disabled={
                  card_amount?.quantitiesIndex ===
                  card?.quantities?.length - 1
                }
              >
                <PlusCircleOutlined />
              </Button>
              
            </div>
          </Spin>
            }
            {showFavCard ? 
                  <div className="product-fav-dlt fav-card-share">
                    {card?.isFavorite &&  <DeleteFilled
                    className="dlt-btn"
                    onClick={() => this.handelFavProduct(card)}
                  />
                    }
                    <img className="share-btn" src={share} alt="share" /> 
              </div> 
                  :  
            <div className="product-fav-dlt">
                <DeleteFilled
                    className="dlt-btn"
                    onClick={() => this.handelDltProduct(card)}
                  />
                  {card?.isFavorite ? <HeartFilled style={{ color : "#ff4d4f" }} onClick={() => this.handelFavProduct(card)} /> : <HeartTwoTone 
                  onClick={() => this.handelFavProduct(card)}
                  twoToneColor={"#00c2ff"} 
                  />}
            </div>
            }
            </div>
            </div> 
          </div>
        ) : (
          <div className="product-card-wrapper">
            {card?.percentageValue !== 0 && ( 
              <p className="product-discount">{card?.percentageValue}%</p>
            )}
            {/* <div className="product-img" onClick={() => this.props.history.replace({ pathname: `/product/${card?.id}/${card?.name}` })}> */}
            <div className="product-img ww" onClick={() => this.props.history.push(`/product/${card?.id}/${card?.name}`) }>  
            {/* <Link > */} 
              <Image 
                src={card?.image_link || card?.image || fallbackImg}
                fallback={fallbackImg} 
                preview={false}
                />
                {/* </Link>  */}
            </div>
            <h6 className="product-name">{card?.name || card?.title}</h6>
            <div className="price-holder">
              <p className="price-after">
                {card?.discount_price ? card?.price : card?.price} {localization.AED[currentLang]}
              </p>
              {card?.discount_price && ( 
                <p className="price-before">{card?.discount_price} {localization.AED[currentLang]}</p> 
              )}
            </div>
            <div className="card-control">
              {isCardAdded ? (
                <Spin
                  indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />}
                  spinning={updateLoading}
                >
                  <div className="card-count-holder">
                    <Button
                      onClick={() => this.handelUpdateProduct("dec")}
                      disabled={card_amount?.quantitiesIndex === 0}
                    >
                      <MinusCircleOutlined />
                    </Button>
                    <p className="product-count">
                      {isCardAdded
                        ? card_amount?.quantities[card_amount?.quantitiesIndex]
                        : null}
                    </p>
                    <Button
                      onClick={() => this.handelUpdateProduct("inc")}
                      disabled={
                        card_amount?.quantitiesIndex ===
                        card?.quantities?.length - 1
                      }
                    >
                      <PlusCircleOutlined />
                    </Button>
                    <DeleteFilled
                      className="dlt-btn"
                      onClick={() => this.handelDltProduct(card)}
                    />
                  </div>{" "}
                </Spin>
              ) : (
                <Button
                  loading={btnLoading}
                  type="primary"
                  size="large"
                  block
                  onClick={() => this.handelAddProductToCart(card)}
                >
                  {localization.Addtocart[currentLang]}
                </Button>
              )}
            </div>
          </div>
        )}
      </>
    );
  }
}

const ProductCardWithRouter = withRouter(ProductCard);

const mapStateToProps = (state) => ({
  cartItems: state.cart.cartItems,
  currentLang : state.user.currentLang,
}); 

export default connect(mapStateToProps)(ProductCardWithRouter);
